import { useRef } from "react";

let count = 0;

/**
 * Generate a unique ID that is stable accross renders for a component. Useful for linking together
 * components for accessibility.
 *
 * @param prefix - Prefix for the generated ID. For the ID to be valid, this must start with a letter.
 */
export default function useUniqueId(prefix = "czi$"): string {
  const ref = useRef<string>();

  if (!ref.current) {
    count += 1;
    ref.current = `${prefix}${count}`;
  }

  return ref.current;
}
